import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

// import attachMock from '../factories/attachMock'
// import MOCK_RESPONSES from './Offers.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_CMS_CONTENT_API_BASE_URL,
})
const loyalty = new APIClient({
  baseURL: process.env.REACT_APP_LOYALTY_API_BASE_URL,
})

export const getAllNewOffers = (accessToken, limit = '') =>
  client({
    method: 'get',
    url: `/loyalty/offers/recent?limit=${encodeURIComponent(limit)}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getAllOffers = (accessToken, limit = '') =>
  client({
    method: 'get',
    url: `/loyalty/offers?limit=${encodeURIComponent(limit)}`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getOffer = (id, accessToken) =>
  client({
    method: 'get',
    url: `/loyalty/offers/${encodeURIComponent(id)}`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const activateOffer = (id, accessToken) =>
  client({
    method: 'post',
    url: `/loyalty/offers/${encodeURIComponent(id)}/activate`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getAllRewards = (accessToken, limit = '', catalogId) =>
  loyalty({
    method: 'get',
    url: `/catalog/rewards/${catalogId}/?limit=${limit}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getReward = (rewardId, accessToken) =>
  loyalty({
    method: 'get',
    url: `/catalog/rewards/${rewardId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getRewardsByMerchant = (merchantId, accessToken) =>
  loyalty({
    method: 'get',
    url: `/catalog/merchants/${merchantId}/rewards`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })

export const getRewardsCatalog = accessToken =>
  loyalty({
    method: 'get',
    url: '/catalog',
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })

export const getAllRewardsMerchants = accessToken =>
  loyalty({
    method: 'get',
    url: '/catalog/merchants',
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })

export const getRewardsMerchants = ({ accessToken, catalogId = 0 }) =>
  loyalty({
    method: 'get',
    url: `/catalog/${catalogId}/merchants`,
    headers: {
      // Authorization: `Bearer ${accessToken}`,
    },
  })
